import React from 'react'
import { PageTrail } from '../../../../shared/sso-workspace/page-trail'
import { SECTION } from '../../../../shared/navigation/sections'

// AI tools telemetry's trail in the admin's top bar: AI tools telemetry >
// Sessions | Postmortems | Findings (the list page's tab), and ... > Sessions
// > <session> or ... > Postmortems > <postmortem> on a page, and ... >
// Recycle bin > Sessions | Records | Postmortems | Findings. The first crumb
// is the sidebar's entry, its name and robot (shared/navigation/sections.js);
// Platform, the sidebar's group, is no page, so it is no crumb (audit F18).
export const TAB_LABELS = { sessions: 'Sessions', postmortems: 'Postmortems', findings: 'Findings' }

export const tabCrumb = key => ({ url: `/admin/ai-tools?tab=${key}`, text: TAB_LABELS[key] })

export const recycleCrumb = () => ({ url: '/admin/ai-tools/recycle', text: 'Recycle bin' })

export const aiToolsTrail = (...crumbs) => [
  SECTION.aiTools,
  ...crumbs
]

// crumbs: the crumbs after AI tools telemetry; a name still loading is ''.
export const AiToolsTrail = ({ crumbs = [] }) => <PageTrail trail={aiToolsTrail(...crumbs)} />
